import { render, staticRenderFns } from "./share-box.vue?vue&type=template&id=2561c739&"
import script from "./share-box.vue?vue&type=script&lang=js&"
export * from "./share-box.vue?vue&type=script&lang=js&"
import style0 from "./share-box.vue?vue&type=style&index=0&id=2561c739&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports